import axios from 'axios';

export default {
    async getStudy(name, domain, token) {
        return new Promise((resolve, reject) => {
            const params = new URLSearchParams();

            if (domain !== undefined) {
                params.append('domain', domain);
            }

            if (name !== undefined) {
                params.append('name', name);
            }

            if (token !== undefined) {
                params.append('token', token);
            }

            axios.get('/api/studies/dashboard', {
                params,
            }).then((r) => {
                resolve(r);
            }).catch((r) => {
                reject(r);
            });
        });
    },

    async getStudies() {
        return new Promise((resolve, reject) => {
            axios.get('/api/studies').then((r) => {
                resolve(r);
            }).catch((r) => {
                reject(r);
            });
        });
    },

    async createStudy(study) {
        return new Promise((resolve, reject) => {
            axios.post('/api/studies', study).then((r) => {
                resolve(r);
            }).catch((r) => {
                reject(r);
            });
        });
    },

    async updateStudy(study) {
        return new Promise((resolve, reject) => {
            axios.put(`/api/studies/${study.id}`, study).then((r) => {
                resolve(r);
            }).catch((r) => {
                reject(r);
            });
        });
    },

    async deleteStudy(id) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/studies/${id}`).then((r) => {
                resolve(r);
            }).catch((r) => {
                reject(r);
            });
        });
    },

    async updatePatientEnrollment(id, data) {
        return new Promise((resolve, reject) => {
            axios.post(`/api/studies/${id}/patient-enrollment`, data).then((r) => {
                resolve(r);
            }).catch((r) => {
                reject(r);
            });
        });
    },
};
